import { render, staticRenderFns } from "./Oiliness.vue?vue&type=template&id=2b084981"
import script from "./Oiliness.vue?vue&type=script&lang=js"
export * from "./Oiliness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports